import Http from './Http';
import { detectDevice } from '../utils/device.js';

export const getCommonInfo = () => {
    return Http.get('/public/common-info');
};

export const getCommonInfoImg = () => {
    return Http.get('/public/common-info-img');
};

export const postLogin = (data) => {
    return Http.post('/login', data);
};

export const putUpdateMemberRole = (data) => {
    return Http.put('/login-update', data);
};

export const postLogout = () => {
    return Http.post('/auth/logout');
};

export const postRefreshToken = (token) => {
    return Http.post('/auth/refresh', token);
};

export const getCode = (code) => {
    return Http.get(`/0x0000/code-by-kind/${code}`);
};

export const getListCode = (code) => {
    return Http.get(`/0x0000/code-by-list-kind/${code}`);
};

export const getPAGAA000 = () => {
    return Http.get('/public/PAGAA000');
};

export const getDownloadFile = async (folderName, fileName) => {
    try {
        const response = await Http.get(`/v1/files/${folderName}/${fileName}/download`, {
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.log(error);
        window.alert('파일을 찾을 수 없습니다.');
    }
};

export const getPAEAA010search = () => {
    return Http.get('/public/PAEAA010/search');
};

export const postPAEAA010list = (data) => {
    return Http.post('/public/PAEAA010', data);
};

export const getPAEAA010 = () => {
    return Http.get(`/public/PAEAA010`);
};

export const getPAEAA010Apply = (data) => {
    return Http.get('/public/PAEAA010/apply', data);
};

export const getPAFAA010 = (id) => {
    return Http.get(`/public/PAFAA010/${id}`);
};

export const getPAIAB010 = (id) => {
    return Http.get(`/public/PAIAB010/${id}`);
};

export const getPAFAA010search = () => {
    return Http.get('/public/PAFAA010/search');
};

export const postPAFAA010list = (data) => {
    return Http.post('/public/PAFAA010', data);
};

export const getPAFAA070detail = (seq) => {
    return Http.get(`/public/PAEAA070/${seq}`);
};

export const getPAFAA070detailbs = (seq, bs) => {
    return Http.get(`/public/PAEAA070/${seq}?bs=${bs}`);
};

// PABAA010
export const postPABAA010resume = (config) => {
    return Http.post('/public/PABAA010/resume', config);
};
export const postPABAA010recruit = (config) => {
    return Http.post('/public/PABAA010/recruit', config);
};
export const postPABAA010news = (config) => {
    return Http.post('/public/PABAA010/news', config);
};
export const postPABAA010event = (config) => {
    return Http.post('/public/PABAA010/event', config);
};

// PAGAA010
export const postPAGAA010Volunteer = (data) => {
    return Http.post('/public/PAGAA010', data);
};

export const getPAGAA020 = (data) => {
    return Http.get(`/public/PAGAA020/${data}`);
};

// PAGAA010
export const postPAGAB010EventList = (data) => {
    return Http.post('/public/PAGAB010', data);
};
// PAGAB020
export const postPAGAB020 = (seq, data) => {
    return Http.post(`/public/PAGAB020/${seq}`, data);
};

export const submitEvent = (data) => {
    return Http.post(`/public/MAGAC020/submit`, data);
};


export const postPAGAB020Regis = (data) => {
    return Http.post(`/public/PAGAB020/regis`, data);
};

export const postPAGAB020Reply = (data) => {
    return Http.post(`/public/PAGAB020/reply`, data);
};

export const putPAGAB020Reply = (data) => {
    return Http.put(`/public/PAGAB020/reply`, data);
};

export const postPAGAB020ReplyDelete = (seq) => {
    return Http.post(`/public/PAGAB020/reply/delete?seq=${seq}`);
};

// PAIAE010
export const postPAIAE010 = (config) => {
    return Http.post(`/public/PAIAE010`, config);
};

export const postPAIAE010DelChoice = (id) => {
    return Http.post(`/public/PAIAE010/del-choice/${id}`);
};

export const postPAIAE010Choice = (data) => {
    return Http.post(`/public/PAIAE010/add-choice`, data);
};

// PAIAF010
export const postPAIAF010 = (config) => {
    return Http.post(`/public/PAIAF010`, config);
};

export const deleteMAKAB020 = (seq, memberID) => {
    return Http.put(`/public/MAKAB020/${seq}/${memberID}`);
};

// PAIAF020
export const getPAIAF020 = (seq) => {
    return Http.get(`/public/PAIAF020/${seq}`);
};
// PAIAF030
export const postPAIAF030 = (config) => {
    return Http.post(`/public/PAIAF030`, config);
};
export const putMAKAB030 = (seq, memberID) => {
    return Http.put(`/public/MAKAB030/${seq}/${memberID}`);
};
export const putMAKAB020 = (seq, memberID) => {
    return Http.put(`/public/MAKAB020/${seq}/${memberID}`);
};
// PAIAB010
export const getPAIAB010Info = () => {
    return Http.get('/public/PAIAB010/data-info');
};

export const postPAIAB010 = (formData) => {
    return Http.post('/public/PAIAB010', formData, {
        headers: {
            Accept: 'application/json',
        },
    });
};

export const putPAIAB010 = (formData) => {
    return Http.put(`/public/PAIAB010`, formData, {
        headers: {
            Accept: 'application/json',
        },
    });
};

// PAIAC010
export const postPAIAC010 = (data) => {
    return Http.post(`/public/PAIAC010`, data);
};

export const putPAIAC010 = (seq) => {
    return Http.put(`/public/PAIAC010/${seq}`);
};

export const deletePAIAC010 = (seq) => {
    return Http.post(`/public/PAIAC010/delete/${seq}`);
};

// PAIAH010
export const getPAIAH010 = (data) => {
    return Http.get(`/PAIAH010?plainPassword=${data}`);
};

export const getPAIAH010_2 = (data) => {
    return Http.get(`/PAIAH010`, data);
};

// PAIAH020
export const getPAIAH020 = () => {
    return Http.get('/public/PAIAH020');
};

export const putPAIAH020 = (data) => {
    return Http.put('/public/PAIAH020', data);
};

export const putPAIAH020ChangePassword = (data) => {
    return Http.put('/public/PAIAH020/update-password', data);
};

// PAIAH030
export const postPAIAH030 = (data) => {
    return Http.post(`/public/PAIAH030`, data);
};

// PAIAC020
export const getPAIAC020 = () => {
    return Http.get(`/public/PAIAC020`);
};

// PAJAC010
export const postPAJAC010 = (config) => {
    return Http.post(`/public/PAJAC010`, config);
};

export const putPAJAC010Reset = (seq) => {
    return Http.put(`/public/PAJAC010/reset-view-count/${seq}`);
};

export const putPAJAC010Clone = (seq) => {
    return Http.put(`/public/PAJAC010/clone/${seq}`);
};

export const postPAJAC010CloneReady = (seq) => {
    return Http.post(`/public/PAJAC010/clone-ready/${seq}`);
};

export const putPAJAC010JumpUp = (seq) => {
    return Http.put(`/public/PAJAC010/jumpup/${seq}`);
};

export const putPAJAC010Expired = (seq) => {
    return Http.put(`/public/PAJAC010/update-expired/${seq}`);
};

export const postPAJAC010Delete = (flag, seq) => {
    return Http.post(`/public/PAJAC010/delete/${flag}/${seq}`);
};

// PAHAA010
export const getPAHAA010 = () => {
    return Http.get('/public/PAHAA010');
};

// PAHAB010
export const getPAHAB010 = () => {
    return Http.get('/public/PAHAB010');
};

// PAHAE010
export const postPAHAE010 = (data) => {
    return Http.post('/public/PAHAE010', data);
};

export const getPAHAE010UpdateView = (seq) => {
    return Http.get(`/public/PAHAE010/update-view?seq=${seq}`);
};

// PAHAF010
export const postPAHAF010 = (data) => {
    return Http.post('/public/PAHAF010', data);
};

// PAHAF020
export const getPAHAF020 = (data) => {
    return Http.get(`/public/PAHAF020/${data}`);
};

// PAIAA010
export const postPAIAA010 = (data) => {
    return Http.post('/public/PAIAA010', data);
};
// PAJAA010
export const getPAJAA010 = () => {
    return Http.get('/public/PAJAA010');
};

// PAGAI010
export const postPAGAI010Document = (data) => {
    return Http.post('/public/PAGAI010', data);
};

// PAIAB020
export const postPAIAB020List = (config) => {
    return Http.post(`/public/PAIAB020`, config);
};

export const getPAIAB020Download = async (seq, fileName) => {
    try {
        const response = await Http.get(`/resume-to-word/${seq}`, {
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.docx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.log(error);
        window.alert('파일을 찾을 수 없습니다.');
    }
};

// PAIAB030
export const getPAIAB030 = (seq) => {
    return Http.get(`/public/PAIAB030/${seq}`);
};

export const putPAIAB020Toggle = (seq) => {
    return Http.put(`/public/PAIAB020/toggle/${seq}`);
};

export const putPAIAB020JumpUp = (seq) => {
    return Http.put(`/public/PAIAB020/jumpUp/${seq}`);
};

export const putPAIAB020Reset = (seq) => {
    return Http.put(`/public/PAIAB020/reset/${seq}`);
};

export const postPAIAB020Clone = (seq) => {
    return Http.post(`/public/PAIAB020/clone/${seq}`);
};

export const deletePAIAB020 = (seq) => {
    return Http.post(`/public/PAIAB020/delete/${seq}`);
};

export const postPAGAC010 = (data) => {
    return Http.post(`/public/PAGAC010`, data);
};

export const getPAGAC020 = (seq) => {
    return Http.get(`/public/PAGAC020/${seq}`);
};

// PAJAD010
export const postPAJAD010 = (data) => {
    return Http.post(`/public/PAJAD010`, data);
};

export const postPAJAD010Accept = (seq) => {
    return Http.post(`/public/PAJAD010/accept/${seq}`);
};
// PAJAC060
export const deletePAJAC060 = (seq) => {
    return Http.post(`/public/PAJAC060/delete/${seq}`);
};

export const postPAJAC060 = (recruitSeq, data) => {
    return Http.post(`/public/PAJAC060/${recruitSeq}`, data);
};

export const putPAJAC060 = (data) => {
    return Http.put('/public/PAJAC060', data);
};

// PAJAC070
export const postPAJAC070 = (recruitSeq, data) => {
    return Http.post(`/public/PAJAC070/${recruitSeq}`, data);
};

// PAFAA060
export const getPAFAA060 = (seq) => {
    return Http.get(`/public/PAFAA060/${seq}`);
};

export const getPAFAA060Snapshot = (seq) => {
    return Http.get(`/public/PAFAA060/snapshot/${seq}`);
};

// PAJAG010
export const postPAJAG010 = (data) => {
    return Http.post(`/public/PAJAG010`, data);
};

// PACAB010
export const postPACAB010 = (data) => {
    return Http.post(`/public/PACAB010`, data);
};

// send OTP find password
export const postPACAB010AuthOtp = (data) => {
    return Http.post('/public/PACAB010/auth-otp', data);
};

export const postPACAC010 = (data) => {
    return Http.post(`/public/PACAC010`, data);
};

// send OTP find memberId
export const postPACAC010AuthOtp = (data) => {
    return Http.post('/public/PACAC010/auth-otp', data);
};

// PADAC010
export const postPADAC010 = (data) => {
    return Http.post(`/public/PADAC010`, data);
};

export const getPADAC010Member = (data) => {
    return Http.get(`/public/PADAC010/exists-member`, data);
};

export const getPADAC010MemberId = (memberId) => {
    return Http.get(`/public/PADAC010/check-member-id-exists`, memberId);
};

export const postPADAC010Integrate = (data) => {
    return Http.post(`/public/PADAC010/integrate`, data);
};

export const getPAAAA010 = () => {
    return Http.get(`/public/PAAAA010`);
};

export const getPAAAA011 = () => {
    return Http.get(`/public/PAAAA011`);
};

export const putPAAAA010Banner = (seq) => {
    const deviceType = detectDevice();
    const device = ['android', 'ios'].includes(deviceType) ? 'mb' : 'pc';

    return Http.put(`/public/PAAAA010?seq=${seq}&device=${device}`);
};

export const putPAAAA010ClickBanner = (seq) => {
    const deviceType = detectDevice();
    const device = ['android', 'ios'].includes(deviceType) ? 'mb' : 'pc';
    return Http.put(`/public/PAAAA010/bannerAD-update-view?seq=${seq}&device=${device}`);
};

export const getPAJAJ010 = (authPass) => {
    return Http.get('/public/PAJAJ010', authPass);
};

export const putPAJAJ010 = (data) => {
    return Http.put('/public/PAJAJ010', data);
};

export const postPayment = (data) => {
    return Http.post('/public/PAJAC020/signature', data);
};

// PAJAH010
export const postPAJAH010 = (data) => {
    return Http.post('/public/PAJAH010', data);
};

export const getPAJAH020 = (seq) => {
    return Http.get(`/public/PAJAH020/${seq}`);
};

export const postPAJAE010 = (data) => {
    return Http.post(`/public/PAJAE010`, data);
};

// PAJAK010
export const postPAJAK010 = (data) => {
    return Http.post(`/public/PAJAK010`, data);
};

// PAJAL010
export const postPAJAL010 = (data) => {
    return Http.post(`/public/PAJAL010`, data);
};

export const postPAJAL010Delete = (unlockSeq) => {
    return Http.post(`/public/PAJAL010/delete`, null, { params: { unlockSeq } });
};

// 이력서 열람권 사용
export const postResumeUnlock = (data) => {
    return Http.post(`/public/resume-access/activate`, data);
};

// 열람권 "사용하기"
export const postResumeActivatePackage = (orderNo) => {
    return Http.post(
        `/public/resume-access/activate-package?orderNo=${encodeURIComponent(orderNo)}`
    );
};

// PAJAI010
export const postPAJAI010 = (config) => {
    return Http.post('/public/PAJAI010', config);
};

// PAJAB020
export const getPAJAB020 = () => {
    return Http.get('/public/PAJAB020');
};

export const putPAJAB020 = (formData) => {
    return Http.put('/public/PAJAB020', formData);
};

// PAJAB021
export const getPAJAB021 = () => {
    return Http.get('/public/PAJAB021');
};

// MAKAB020
export const postMAKAB020 = (data) => {
    return Http.post('/public/MAKAB020', data);
};

// PAJAF010
export const postPAJAF010 = (config) => {
    return Http.post('/public/PAJAF010', config);
};

// PAGAC010
export const getPAGAJ010 = () => {
    return Http.get('/public/PAGAJ010');
};

// PAAAA010 Banner
export const getPAAAA010quick = () => {
    return Http.get('/public/PAAAA010/quick');
};

export const getPAAAA010recruit = () => {
    return Http.get('/public/PAAAA010/recruit');
};

export const getPAAAA010resume = () => {
    return Http.get('/public/PAAAA010/resume');
};

export const getPAAAA010lnb = () => {
    return Http.get('/public/PAAAA010/lnb');
};

export const getPAAAA010login = () => {
    return Http.get('/public/PAAAA010/login');
};

export const postPAJAC020Step1 = (data) => {
    return Http.post('/public/PAJAC020/step01', data);
};

export const putPAJAC020Step1 = (data) => {
    return Http.put('/public/PAJAC021', data);
};

export const getPAJAC020 = (id) => {
    return Http.get(`/public/PAJAC020/${id}`);
};

export const getPAJAC020CountBusiness = () => {
    return Http.get('/public/PAJAC020/count-business');
};

export const getPAJAC020CodeList = (code) => {
    return Http.get(`/public/PAJAC020/code-list/${code}`);
};
export const getPAJAC020CodeListPublic = (code) => {
    return Http.get(`/public/PAJAC020/code-list-public/${code}`);
};
export const getPAJAC020TaskManager = () => {
    return Http.get(`/public/PAJAC020/task-manager`);
};

export const getPAJAC020Ticket = () => {
    return Http.get('/public/PAJAC020/ticket');
};

export const getPAJAC030Goods = () => {
    return Http.get('/public/PAJAC030/goods');
};

export const getPAJAC020BusinessDate = () => {
    return Http.get('/public/PAJAC020/business-check');
};


export const postPAHAD010 = (data) => {
    return Http.post('/public/PAHAD010', data);
};

export const getPAJAC050Details = (type, seq) => {
    return Http.get(`/public/PAJAC050/${type}/${seq}`);
};

export const getRecruitReadyYN = (data) => {
    return Http.get('/public/PAJAC022', data);
};

export const getPAJAC050DetailsRD = (seq) => {
    return Http.get(`/public/PAJAC050/RD/${seq}`);
};
export const getPAJAC050DetailsRC = (seq) => {
    return Http.get(`/public/PAJAC050/RC/${seq}`);
};
export const getPAJAC050DetailsRH = (seq) => {
    return Http.get(`/public/PAJAC050/RH/${seq}`);
};

export const getPAJAC050 = (rc, pm) => {
    return Http.get(`/public/PAJAC050?rc=${rc}&pm=${pm}`);
};

export const postPAJAC020PaymentTicket = (data) => {
    return Http.post('/public/PAJAC020/payment-ticket', data);
};

export const postPAJAC030PaymentTicket = (data) => {
    return Http.post('/public/PAJAC030/payment-ticket', data);
};

export const postPAJAC020PaymentDirectBank = (data) => {
    return Http.post('/public/PAJAC020/payment-directBank', data);
};

export const getPAJAC040 = (seq) => {
    return Http.get(`/public/PAJAC040/${seq}`);
};

export const putPAJAF010UpdateMatching = (data) => {
    return Http.put('/public/PAJAF010/update-matching', data);
};

export const putPAEAA014UpdateMatching = (data) => {
    return Http.put('/public/PAEAA014/update-matching', data);
};

export const putPAIAD010UpdateMatching = (data) => {
    return Http.put('/public/PAIAD010/update-matching', data);
};

export const postPAIAD010 = () => {
    return Http.post('/public/PAIAD010');
};

export const putPAGAB020CommentLike = (seq) => {
    return Http.put(`/public/PAGAB020/comment-likes?commentSeq=${seq}`);
};

export const putPAGAB020CommentLikeV2 = (seq, count) => {
    return Http.put(`/public/PAGAB020/comment-likes-v2?commentSeq=${seq}&count=${count}`);
};


export const getRecruitsNeareast = (pointX, pointY) => {
    return Http.get(`/public/PAEAA070/recruits-nearest?pointX=${pointX}&pointY=${pointY}`);
};

export const uploadRecruitImage = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return Http.post("/v1/files/upload-recruit-img", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

// KCP 휴대폰 본인인증
export const postKcpCertStart = (data) => {
    return Http.post('/public/kcp-cert/start', data);
};

export const getKcpCertResult = (ordrIdxx) => {
    return Http.get(`/public/kcp-cert/result/${encodeURIComponent(ordrIdxx)}`);
};

export const getPADAC010ExistsMemberCert = (kcpOrdrIdxx) => {
    return Http.get('/public/PADAC010/exists-member-cert', { params: { kcpOrdrIdxx } });
};

// Trang login: kiểm tra / lưu CI của tài khoản vừa đăng nhập. Token chưa lưu vào store nên truyền header trực tiếp
export const getPACAA010CiStatus = (token) => {
    return Http.get('/public/PACAA010/ci-status', { headers: { Authorization: `Bearer ${token}` } });
};

export const postPACAA010Ci = (token, kcpOrdrIdxx) => {
    return Http.post('/public/PACAA010/ci', { kcpOrdrIdxx }, { headers: { Authorization: `Bearer ${token}` } });
};

export const postLogoutWithToken = (token) => {
    return Http.post('/auth/logout', null, { headers: { Authorization: `Bearer ${token}` } });
};
